import React from 'react'
import maingaetecollege from "../images/MAIN GATE college.jpeg";
import mainbuild from "../images/ABOUT SLIDER PAGE.jpg";

function Aboutslider() {
  return (
    <div>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={mainbuild} className="d-block w-100" alt="olive academy"/>
    </div>
    <div className="carousel-item">
      <img src={maingaetecollege} className="d-block w-100" alt="Olive Academy"/>
    </div>
 
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Aboutslider